import React, { Component } from 'react'
import 'react-vis/dist/style.css'
import { OrdinalFrame } from 'semiotic'
import * as moment from 'moment'
import { withStyles } from 'material-ui/styles'
import { Button, Grid } from 'material-ui'
import IconButton from 'material-ui/IconButton'
import ChevronLeftIcon from 'material-ui-icons/ChevronLeft'
import ChevronRightIcon from 'material-ui-icons/ChevronRight'

var minTime = moment()
var maxTime = moment()
var action = ''
var goal = ''

const styles = theme => ({
  tooltipContent: {
    background: 'white',
    border: 1,
    color: 'black',
    padding: 10
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200
  },
  divAlign: {
    marginLeft: -theme.spacing.unit * 5,
    width: window.innerWidth
  },
  divChartBurnDown: {
    position: 'absolute',
    marginLeft: theme.spacing.unit * 5
  }
})

@withStyles(styles)
export default class AlchemySleepWeeklyAvg extends Component {
  constructor(props) {
    super(props)
    this.state = {
      burnStartDate: moment(new Date(this.props.goal.goalStartDate)).startOf(
        'week'
      ),
      weeksChange:
        this.props.goal.incrementalChangeMins === 0
          ? 8
          : (
              moment
                .duration(
                  moment
                    .utc(
                      moment(this.props.goal.timeCompleteFrom, 'HH:mm:ss').diff(
                        moment(this.props.goal.timeCompleteTo, 'HH:mm:ss')
                      )
                    )
                    .format('HH:mm')
                )
                .asMinutes() / this.props.goal.incrementalChangeMins
            ).toFixed(0)
    }
  }

  timelineSleep = ({ data, rScale, adjustedSize, margin }) => {
    const renderedPieces = []

    const keys = Object.keys(data)

    //todo: scale
    const widthBar = 30

    keys.forEach(key => {
      //Only one piece of data per column though we'll render multiple graphical elements
      const column = data[key]
      const sleep = column.pieceData[0]

      //You can return an array of graphics or an array of objects with extra data (see the Waterfall chart demo)
      const markObject = (
        <g
          key={`piece-${key}`}
          cursor={
            moment(new Date(sleep.data.date)).isAfter(moment(), 'day')
              ? 'auto'
              : 'pointer'
          }
          onClick={
            moment(new Date(sleep.data.date)).isAfter(moment(), 'day') ||
            action === ''
              ? () => {
                  console.log('action to add')
                }
              : () => {
                  sleep.data.type === 'blank'
                    ? action(sleep.data.date, 'add')
                    : action(sleep.data.date, 'other')
                }
          }
        >
          {column.pieceData.map((s, index) => (
            <g key={`stack-rect-${index}`}>
              {s.data.type === 'goalpattern' && (
                <rect
                  key={`rect-goal-${key}`}
                  fill={'rgba(0, 0, 0, 0.16)'}
                  opacity={0.5}
                  width={column.width > 0 ? column.width * 7 : widthBar}
                  height={
                    rScale(new Date(s.data.barEnd)) -
                      rScale(new Date(s.data.barStart)) >
                    0
                      ? rScale(new Date(s.data.barEnd)) -
                        rScale(new Date(s.data.barStart))
                      : 3
                  }
                  x={column.x}
                  y={
                    rScale(maxTime) -
                    rScale(new Date(s.data.barEnd)) +
                    rScale(minTime)
                      ? rScale(maxTime) -
                        rScale(new Date(s.data.barEnd)) +
                        rScale(minTime)
                      : 3
                  }
                  rx={3}
                  ry={3}
                />
              )}
              {s.data.type === 'sessionRecord' && (
                <rect
                  key={`rect-${key}`}
                  fill={
                    moment(
                      moment(new Date(s.data.barEnd)).format('h:mma'),
                      'h:mma'
                    ).isBefore(moment('6:01am', 'h:mma'))
                      ? 'green'
                      : 'darksalmon'
                  }
                  opacity={0.3}
                  width={1}
                  height={
                    rScale(new Date(s.data.barEnd)) -
                      rScale(new Date(s.data.barStart)) >
                    0
                      ? rScale(new Date(s.data.barEnd)) -
                        rScale(new Date(s.data.barStart))
                      : 3
                  }
                  x={column.x}
                  y={
                    rScale(maxTime) -
                    rScale(new Date(s.data.barEnd)) +
                    rScale(minTime)
                      ? rScale(maxTime) -
                        rScale(new Date(s.data.barEnd)) +
                        rScale(minTime)
                      : 3
                  }
                  rx={3}
                  ry={3}
                />
              )}
              {s.data.type === 'weeklyAvg' && (
                <rect
                  key={`rect-pred-${key}`}
                  fill={'lightgreen'}
                  opacity={0.5}
                  width={column.width > 0 ? column.width * 7 : widthBar}
                  height={
                    rScale(new Date(s.data.barEnd)) -
                      rScale(new Date(s.data.barStart)) >
                    0
                      ? rScale(new Date(s.data.barEnd)) -
                        rScale(new Date(s.data.barStart))
                      : 3
                  }
                  x={column.x}
                  y={
                    rScale(maxTime) -
                    rScale(new Date(s.data.barEnd)) +
                    rScale(minTime)
                      ? rScale(maxTime) -
                        rScale(new Date(s.data.barEnd)) +
                        rScale(minTime)
                      : 3
                  }
                  rx={3}
                  ry={3}
                />
              )}
              {s.data.type === 'weeklyAvg' && (
                <text
                  key={`rect-pred-text-end-${key}`}
                  fill={'darkgreen'}
                  fontSize={adjustedSize[0] / 27}
                  opacity={0.5}
                  x={column.x}
                  y={
                    rScale(maxTime) -
                    rScale(new Date(s.data.barEnd)) +
                    rScale(minTime)
                      ? -adjustedSize[0] / 80 +
                        rScale(maxTime) -
                        rScale(new Date(s.data.barEnd)) +
                        rScale(minTime)
                      : 3
                  }
                >
                  {moment(new Date(s.data.barEnd)).format('HH:mm')}
                </text>
              )}
              {s.data.type === 'weeklyAvg' && (
                <text
                  key={`rect-pred-text-start-${key}`}
                  fill={'darkgreen'}
                  fontSize={adjustedSize[0] / 27}
                  opacity={0.5}
                  x={column.x}
                  y={
                    rScale(maxTime) -
                    rScale(new Date(s.data.barEnd)) +
                    rScale(minTime)
                      ? adjustedSize[0] / 28 +
                        rScale(maxTime) +
                        rScale(minTime) -
                        rScale(new Date(s.data.barStart))
                      : 3
                  }
                >
                  {moment(new Date(s.data.barStart)).format('HH:mm')}
                </text>
              )}
            </g>
          ))}
        </g>
      )

      renderedPieces.push(markObject)
    })

    return renderedPieces
  }

  addBlankDate = (s, w, data) => {
    var iDateStart = moment(new Date(this.state.burnStartDate)).startOf('week')
    var iDateEnd = moment(new Date(this.state.burnStartDate))
      .add(w, 'weeks')
      .endOf('week')
    var daysWeek = iDateEnd.diff(iDateStart, 'days') + 1

    for (var i = 0; i < daysWeek; i++) {
      var blankDate = iDateStart
      var isSame = false

      for (var j in data) {
        if (
          moment(new Date(data[j].date)).format('l') === blankDate.format('l')
        ) {
          isSame = true
        }
      }
      if (!isSame) {
        data.splice(i, 0, {
          date: blankDate.format('l'),
          barStart: moment(new Date(s))
            .day('sunday')
            .hour('23')
            .minute('0')
            .second('0')
            .format('MM/DD/YYYY HH:mm'),
          barEnd: moment(new Date(s))
            .day('monday')
            .hour('7')
            .minute('0')
            .second('0')
            .format('MM/DD/YYYY HH:mm'),
          type: 'blank'
        })
        isSame = false
      }

      iDateStart = moment(blankDate).add(1, 'd')
    }

    return data
  }

  calcWeeklyAvg = (date, data) => {
    var avg = ''

    var avgBarStart = []
    var avgBarEnd = []

    var dates = data.filter(
      s =>
        moment(new Date(s.date))
          .startOf('week')
          .format('l') ===
        moment(new Date(date))
          .startOf('week')
          .format('l')
    )

    if (dates && dates.length > 0) {
      dates.forEach(d => {
        avgBarStart.push(moment(new Date(d.barStart)))
        avgBarEnd.push(moment(new Date(d.barEnd)))
      })

      var minBarStar = moment.min(avgBarStart)
      var minBarEnd = moment.min(avgBarEnd)

      var minsDiff = 0
      var minsDiffEnd = 0
      avgBarStart.forEach(a => {
        minsDiff = minsDiff + a.diff(minBarStar, 'minutes')
      })
      avgBarEnd.forEach(a => {
        minsDiffEnd = minsDiffEnd + a.diff(minBarEnd, 'minutes')
      })
      var minsDiffAvg = minsDiff / avgBarStart.length
      var minsDiffAvgEnd = minsDiffEnd / avgBarEnd.length

      avgBarStart = minBarStar.add(minsDiffAvg, 'minutes')
      avgBarEnd = minBarEnd.add(minsDiffAvgEnd, 'minutes')

      avg = {
        date: date,
        barStart: avgBarStart.format('MM/DD/YYYY HH:mm'),
        barEnd: avgBarEnd.format('MM/DD/YYYY HH:mm'),
        type: 'weeklyAvg'
      }
    }
    return avg
  }

  prevPeriod = () => {
    const prevPeriod = moment(new Date(this.state.burnStartDate)).subtract(
      this.state.weeksChange + 1,
      'weeks'
    )
    this.setState({
      burnStartDate: prevPeriod.startOf('week')
    })
  }

  nextPeriod = () => {
    const nextPeriod = moment(new Date(this.state.burnStartDate)).add(
      this.state.weeksChange + 1,
      'weeks'
    )
    this.setState({
      burnStartDate: nextPeriod.startOf('week')
    })
  }

  setToday = () => {
    this.setState({
      burnStartDate: moment(new Date(this.props.goal.goalStartDate)).startOf(
        'week'
      )
    })
  }

  render() {
    if (this.props.data && this.props.data.loading) {
      return <div>Loading</div>
    }

    if (this.props.data && this.props.data.error) {
      return <div>Error</div>
    }

    const { classes } = this.props
    const tmp = this.props.data

    let burnEndDate = moment(new Date(this.state.burnStartDate))
      .endOf('week')
      .add(this.state.weeksChange, 'weeks')

    const dataSleepWeekly = tmp.filter(
      sleep =>
        sleep.nap === '0' &&
        moment(new Date(sleep.date)).isBetween(
          this.state.burnStartDate,
          burnEndDate,
          null,
          []
        )
    )

    var dataChartSleepWeekly = []
    const sleepDays = dataSleepWeekly.length

    // session data
    for (var i = 0; i < sleepDays; i++) {
      const sleepDurationHour =
        dataSleepWeekly[i].timeStart === ''
          ? 0
          : moment(new Date(dataSleepWeekly[i].timeComplete)).diff(
              moment(new Date(dataSleepWeekly[i].timeStart)),
              'hours'
            )
      const sleepDurationMin = moment
        .utc(
          moment(
            new Date(dataSleepWeekly[i].timeComplete),
            'MM/DD/YYYY HH:mm'
          ).diff(
            moment(new Date(dataSleepWeekly[i].timeStart), 'MM/DD/YYYY HH:mm')
          )
        )
        .format('mm')

      var strDate =
        goal.goalStartDate +
        ' ' +
        moment(new Date(dataSleepWeekly[i].timeComplete)).format('HH:mm')

      const barEndTime = moment(new Date(strDate))
        .day('monday')
        .format('MM/DD/YYYY HH:mm')

      dataChartSleepWeekly.splice(
        moment(new Date(dataSleepWeekly[i].date)).day(),
        0,
        {
          date: moment(new Date(dataSleepWeekly[i].date)).format('l'),
          barStart:
            sleepDurationHour === 0
              ? moment(new Date(barEndTime))
                  .subtract(1, 'hour')
                  .subtract(0, 'minute')
                  .format('MM/DD/YYYY HH:mm')
              : moment(new Date(barEndTime))
                  .subtract(sleepDurationHour, 'hour')
                  .subtract(sleepDurationMin, 'minute')
                  .format('MM/DD/YYYY HH:mm'),
          barEnd: barEndTime,
          type: dataSleepWeekly[i].type
        }
      )
    }

    //add goalpattern and average weekly data
    for (i = 0; i <= this.state.weeksChange; i++) {
      var predWeeklyDate = moment(new Date(this.state.burnStartDate)).day(
        'monday'
      )
      var str =
        goal.incrementalChangeMins === 0
          ? goal.goalStartDate + ' ' + goal.timeCompleteTo
          : goal.goalStartDate + ' ' + goal.timeCompleteFrom
      var barEndTime = moment(str, 'MM/DD/YYYY HH:mm')
        .subtract(goal.incrementalChangeMins * i, 'minutes')
        .format('MM/DD/YYYY hh:mm A')

      var predData = {
        date: predWeeklyDate
          .add(i, 'week')
          .startOf('week')
          .format('l'),
        barStart: moment(new Date(barEndTime))
          .day('monday')
          .subtract(goal.hrsDurationTo, 'hours')
          .format('MM/DD/YYYY HH:mm'),
        barEnd: moment(new Date(barEndTime))
          .day('monday')
          .format('MM/DD/YYYY HH:mm'),
        type: 'goalpattern'
      }
      dataChartSleepWeekly.splice(0, 0, predData)

      //add average weekly data
      var avgData = this.calcWeeklyAvg(
        predData.date,
        dataChartSleepWeekly.filter(d => d.type === 'sessionRecord')
      )

      if (avgData) {
        dataChartSleepWeekly.splice(0, 0, avgData)
      }
    }

    //add blank days
    dataChartSleepWeekly = this.addBlankDate(
      goal.goalStartDate,
      this.state.weeksChange,
      dataChartSleepWeekly
    )

    var sleepStartTimes = []
    var sleepEndTimes = []

    dataChartSleepWeekly.forEach(s => {
      sleepStartTimes.push(moment(new Date(s.barStart)))
      sleepEndTimes.push(moment(new Date(s.barEnd)))
    })

    minTime = moment.min(sleepStartTimes).subtract(0.4, 'hour')
    maxTime = moment.max(sleepEndTimes).add(0.4, 'hour')

    if (this.props.action) {
      action = this.props.action
    } else {
      action = ''
    }

    if (this.props.goal) {
      goal = this.props.goal
    } else {
      goal = ''
    }

    return (
      <div className={classes.divAlign}>
        <div
          id="switch-weeks"
          style={{
            width: '70%',
            marginLeft: '15%',
            marginRight: '15%'
          }}
        >
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="baseline"
            spacing={0}
          >
            <Grid item xs={2} />
            <Grid item xs={2}>
              <IconButton
                onClick={() => this.prevPeriod()}
                className="btn btn-default btn-style"
              >
                <ChevronLeftIcon style={{ fontSize: 30 }} />
              </IconButton>
            </Grid>
            <Grid item xs={4}>
              <span style={{ fontSize: 14 }}>
                {this.state.burnStartDate.format('M/D')} -{' '}
                {burnEndDate.format('M/D')}
              </span>
            </Grid>
            <Grid item xs={2}>
              <IconButton
                onClick={() => this.nextPeriod()}
                className="btn btn-default btn-style"
              >
                <ChevronRightIcon style={{ fontSize: 30 }} />
              </IconButton>
            </Grid>
            <Grid item xs={2}>
              {moment().isBetween(
                this.state.burnStartDate,
                burnEndDate,
                null,
                '[]'
              ) ? (
                ''
              ) : (
                <Button
                  onClick={() => this.setToday()}
                  className={classes.icon}
                  size="small"
                >
                  <span style={{ fontSize: 10 }}>Today</span>
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
        <div
          id="daily_sleep_chart_view"
          style={{
            position: 'relative',
            textAlign: 'center',
            width: this.props.width,
            height: this.props.height
          }}
        >
          <div className={classes.divChartBurnDown}>
            <OrdinalFrame
              size={[this.props.width / 1.1, this.props.height]}
              data={dataChartSleepWeekly}
              rAccessor={d => new Date(d.barStart)}
              oAccessor={d => moment(new Date(d.date)).format('YYYY/MM/DD')}
              sortO={(a, b) => a > b}
              rExtent={[minTime, maxTime]}
              type={{
                type: this.timelineSleep,
                rotate: 180
              }}
              projection="vertical"
              oPadding={this.props.width / 35}
              axis={[
                {
                  orient: 'left',
                  ticks: 7,
                  tickFormat: d => (
                    <text
                      key={`tick-${d}`}
                      style={{
                        fill: '#cecece',
                        textAnchor: 'end',
                        fontSize: 10
                      }}
                      y={-2}
                    >
                      {moment(new Date(d)).format('h a')}
                    </text>
                  ),
                  tickValues: [
                    new Date(
                      moment(new Date(goal.goalStartDate))
                        .day('monday')
                        .hour('0')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(new Date(goal.goalStartDate))
                        .day('monday')
                        .hour('2')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(new Date(goal.goalStartDate))
                        .day('monday')
                        .hour('4')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(new Date(goal.goalStartDate))
                        .day('monday')
                        .hour('6')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(new Date(goal.goalStartDate))
                        .day('monday')
                        .hour('8')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(new Date(goal.goalStartDate))
                        .day('monday')
                        .hour('10')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(new Date(goal.goalStartDate))
                        .day('monday')
                        .hour('12')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(new Date(goal.goalStartDate))
                        .day('monday')
                        .hour('14')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(new Date(goal.goalStartDate))
                        .day('monday')
                        .hour('16')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(new Date(goal.goalStartDate))
                        .day('monday')
                        .hour('18')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(new Date(goal.goalStartDate))
                        .day('sunday')
                        .hour('20')
                        .minute('0')
                        .second('0')
                    ),
                    new Date(
                      moment(new Date(goal.goalStartDate))
                        .day('sunday')
                        .hour('22')
                        .minute('0')
                        .second('0')
                    )
                  ],
                  baseline: false,
                  tickLineGenerator: ({ xy }) =>
                    xy.ty && (
                      <path
                        key={`tickLine-${xy.x2}-${xy.ty}`}
                        style={{ stroke: '#F0F0F0 ' }}
                        d={`M${xy.x1},${xy.y1}L${xy.x2},${xy.y1}L${xy.x2},${
                          xy.y1
                        }L${xy.x1},${xy.y1}Z`}
                      />
                    )
                }
              ]}
              margin={{
                left: this.props.width / 10,
                top: this.props.height / 60,
                right: this.props.width / 10,
                bottom: this.props.height / 9.6
              }}
              oLabel={d => (
                <text
                  key={`label-${d}`}
                  fill="#cecece"
                  textAnchor="middle"
                  fontSize={10}
                  x={5}
                >
                  {moment(new Date(d)).day() === 0
                    ? moment(new Date(d)).format('M/D')
                    : ''}
                </text>
              )}
              hoverAnnotation={false}
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ChartTypes/AlchemySleepWeeklyAvg.js